/** @module Specification/BOM/PartMaterialOnlyForProductSalesRegions */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/RefContainer",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,_,Action,ViewRef,RefContainer,xml,Query) {
	return declare(RefContainer, {
		PATH_FROM_PM_TO_PRODUCT: "Child:__Parent__/Child:__Parent__/Child:__Parent__",
		PATH_FROM_SOURCE_PM_TO_PRODUCT: "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__",

		_getStoreAction: function(ctx, h, bAll) {
			// For SourceBOMs, need additional steps to take to reach Product from ProductSource
			const bom = ctx.getNodeParent(ctx.getParent());
			const path = xml.isValidURL(bom?.LinkedHostDataSheet) ? this.PATH_FROM_SOURCE_PM_TO_PRODUCT : this.PATH_FROM_PM_TO_PRODUCT;
			//summary: C8-5279 Refinement of "Only for Sales Regions" on PartMaterial
			var viewRef = lang.mixin(new ViewRef(), {
				m_id : "ProductSalesRegions",
				m_path : path
			});

			var query = new Query().Attr("Active", xml.OP_EQUALS, true);

			// C8-5279 : Restrict selection of Sales Regions on PartMaterial based on list of Sales Region Specs on the Material
			var componentUrl = ctx.getNode().Actual;
			var component = xml.isValidURL(componentUrl) ?  ctx.cache.getNode(componentUrl) : null;
			if (component && !_.isEmpty(component.MaterialProductSalesRegionSpecs)) {
				query = query.Node(xml.PROP_URL, xml.OP_EQUALS, componentUrl, "Child:ProductSalesRegionSpec/Parent:MaterialProductSalesRegionSpecs");
			}

			return lang.mixin(new Action(), {
				m_fixedQuery: query,
				m_viewRef : viewRef
			});
		},

		getCustomStoreKey: function(ctx, h, bAll) {
			// summary: Drop-down menu should refreshed per BOM line (C8-5536)
			return ctx.getNodeURL();
		}
	});
});